<template>
  <div>
    <v-container fluid>
      <v-card elevation="0">
        <v-card-title class="secondary--text font-weight-medium pt-5">
          <v-row align="center" no-gutters class="">
            <v-col cols="12">
              <h3 class="my-2 primary--text">
                {{ $t("layout.subscriptions") }}
              </h3>
            </v-col>
            <v-col cols="2">
              <v-text-field
                :label="$t('common.search')"
                v-model="search"
                :placeholder="$t('landlord.landlordName')"
                class="custom-label-color"
                hide-details="auto"
                outlined
                dense
              >
              </v-text-field>
            </v-col>

            <v-col cols="1" class="ml-2">
              <v-btn color="primary" class="white--text" @click="searchData()">
                Search
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>

        <!-- <div id="wrapper2">
          <div id="top-scroll" class="width-scroll-top"></div>
        </div> -->
        <v-data-table
          :footer-props="{ 'items-per-page-options': [50, 100, 150, 200, -1] }"
          class="mt-1 datatable mb-9 table-reference-for-scroll"
          id="landlordSubscriptionTable"
          :headers="headers"
          :items="landlordSubscriptions"
          :hide-default-footer="footer"
          :search="search"
          :loading="loading"
          mobile-breakpoint="0"
          :options.sync="options"
          :server-items-length="totallandlordPlans"
        >
          <template v-slot:[`item._id`]="{ item }">
            <p class="my-0 py-0">
              {{
                options.page * options.itemsPerPage -
                  options.itemsPerPage +
                  landlordSubscriptions
                    .map(function(x) {
                      return x._id;
                    })
                    .indexOf(item._id) +
                  1
              }}
            </p>
          </template>

          <template v-slot:[`item.landlordName`]="{ item }">
            <router-link
              v-if="item.landlord && item.landlord.user"
              :to="{
                name: 'LandLordDetails',
                params: { id: item.landlord._id }
              }"
            >
              {{
                `
                ${item.landlord.user.nameEn}
                `
              }}
            </router-link>
          </template>
          <template v-slot:[`item.startDate`]="{ item }">
            <span v-if="item.startDate">
              {{ dateFormat(item.startDate) }}
            </span>
            <span v-else> -- </span>
          </template>

          <template v-slot:[`item.endDate`]="{ item }">
            <span v-if="item.endDate">
              {{ dateFormat(item.endDate) }}
            </span>
            <span v-else> -- </span>
          </template>

          <template v-slot:[`item.isActive`]="{ item }">
            <span>
              {{
                item.currentStatus === "ADVANCED"
                  ? "PENDING"
                  : item.currentStatus === "EXPIRED"
                  ? "EXPIRED"
                  : item.currentStatus
              }}
            </span>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
// import AddButton from "../../core/components/AddButton.vue";
// import { deleteLandlord } from "../methods/delete_landlord";
import { formatDate } from "@/core/methods/formatDate";
import moment from "moment";
export default {
  data() {
    return {
      loading: false,
      footer: false,
      search: "",
      variables: {
        limit: 50,
        skip: 0
      },
      options: {
        itemsPerPage: 50,
        page: 1
      },
      landlordPlanLists: [],
      landlordSubscriptions: [],
      totallandlordPlans: 0
    };
  },
  components: {
    // "add-button": AddButton,
  },
  computed: {
    headers() {
      return [
        {
          text: "#",
          align: "left",
          value: "_id",
          width: 10
        },
        {
          text: this.$t("landlord.landlordName"),
          align: "left",
          value: "landlordName",
          width: 150
        },
        {
          text: this.$t("plans.name"),
          align: "left",
          value: "landlordValidityPlan.planName",
          width: 150
        },
        {
          text: this.$t("plans.startDate"),
          align: "center",
          value: "startDate",
          width: 150
        },
        {
          text: this.$t("plans.endDate"),
          align: "left",
          value: "endDate",
          width: 150
        },
        {
          text: this.$t("core.amount"),
          align: "left",
          sortable: false,
          value: "amount",
          width: 50
        },
        {
          text: this.$t("landlord.status"),
          align: "left",
          value: "isActive",
          width: 150
        }
      ].map(header => {
        header.align = "center";
        header.sortable = false;
        return header;
      });
    }
  },
  watch: {
    options() {
      // let sortBy = "";
      // switch (val.sortBy[0]) {
      //   case "name":
      //     sortBy = "firstName";
      //     break;
      //   case "user.active":
      //     sortBy = "active";
      //     break;
      //   case "commission":
      //     sortBy = "commission";
      // }
      this.$apollo.queries.getAllLandlordSubscriptions.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totallandlordPlans,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          searchKey: this.search,
          sortBy: "",
          sortDesc: false
        }
      });
    }
  },
  apollo: {
    getAllLandlordSubscriptions() {
      this.loading = true;
      return {
        query: require("@/subscriptions/api/queries/get_all_subscriptions.graphql"),
        fetchPolicy: "no-cache",
        variables: {
          input: {
            limit: 50,
            skip: 0
          },
          filter: {
            searchKey: this.search,
            sortBy: "",
            sortDesc: false
          }
        },
        result({ data, loading }) {
          // , networkStatus, refetch
          this.loading = loading;
          if (data) {
            this.landlordSubscriptions = this.$format.cloneVariable(
              data.getAllLandlordSubscriptions.landlordSubscriptions
            );

            this.totallandlordPlans =
              data.getAllLandlordSubscriptions.totalCount;
          }
        }
      };
    }
  },
  mounted() {
    // let wrapper_1 = document.querySelector(
    //   ".table-reference-for-scroll .v-data-table__wrapper"
    // );
    // let wrapper_2 = document.querySelector("#wrapper2");
    // wrapper_1.onscroll = function() {
    //   wrapper_2.scrollLeft = wrapper_1.scrollLeft;
    // };

    // wrapper_2.onscroll = function() {
    //   wrapper_1.scrollLeft = wrapper_2.scrollLeft;
    // };

    this.$root.$on("landlordSubscriptionTable", () => {
      this.options.itemsPerPage = 50;
      this.$set(this.options, this.options.itemsPerPage, 50);
    });
    this.$root.$on("refetchLandlordSubscription", () => {
      this.$apollo.queries.getAllLandlordSubscriptions.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totallandlordPlans,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          searchKey: this.search,
          sortBy: "",
          sortDesc: false
        }
      });
    });
  },
  methods: {
    searchData() {
      this.loading = true;
      this.$apollo.queries.getAllLandlordSubscriptions.refetch({
        input: {
          limit: this.options.itemsPerPage,
          skip: 0
        },
        filter: {
          searchKey: this.search,
          sortDesc: false,
          sortBy: ""
        }
      });
      this.loading = false;
    },
    editLandlordPlan(item) {
      this.$store.commit("EDIT_LANDLORD_PLAN", item);
      this.$store.commit("IS_EDIT_LANDLORD_PLAN", true);
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
    },
    dateFormat(date) {
      const rawDate = new Date(parseInt(date));
      return moment(rawDate, "YYYY-MM-DD").format("DD-MM-YYYY");
    },
    isExpired(endDate) {
      if (!endDate) return false;
      const today = moment().startOf("day");
      const end = moment(parseInt(endDate)).startOf("day");
      return end.isBefore(today);
    },

    openRightSideDrawer() {
      this.$store.commit("IS_EDIT_LANDLORD_PLAN", false);

      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
    },
    showToggleDialog(item) {
      this.$root.$emit("toggleDialog", {
        dialog: true,
        item: item,
        module: "plans"
      });
      this.$root.$emit("refetchLandlordSubscription");
    },
    formatDate: formatDate
  },
  beforeDestroy() {
    this.$root.$off("landlordPlanTable");
    this.$root.$off("deleteItems");
    this.$root.$off("refetchLandlordSubscription");
    this.$root.$off("toggleItems");
  }
};
</script>
<style scoped>
.datatable >>> .v-data-footer__select {
  direction: ltr !important;
}
.datatable >>> .v-data-footer__pagination {
  direction: ltr !important;
}

/* This is the size of the path of the scrollbar */
#wrapper2 {
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
}

/* This div allow to make the scroll function and show the scrollbar */
#top-scroll {
  height: 1px;
  overflow: scroll;
}

/* This is the size of the scrollbar */
.width-scroll-top {
  width: 2800px;
}
</style>
